// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RBuh","title":"Header_title__TC-ny","left":"Header_left__c2obS","clinicName":"Header_clinicName__quver"};